<template>
    <div class="alert alert-error"
         :class="{'alert-error': (status === 'error'), 'alert-success': (status === 'success'), 'alert-info': (status === 'info')}">
        <span class="alert-inner clearfix">
            <span>{{ alertMessage }}</span>
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            status: {
                required: true,
                type: String,
                validator: function (value) {
                    return ['info', 'success', 'error'].indexOf(value) !== -1;
                }
            },
            alertMessage: {
                required: true,
                type: String,
                default: '',
            },
        },
        methods: {
        },
        mounted() {
            this.settingValue = this.currentSetting
        }
    }
</script>
